import { __assign, __extends } from "tslib";
import React, { Component } from 'react';
import { View, Text, Image, Platform, TouchableOpacity, ScrollView, Alert } from 'react-native';
import { PnmacSectionListView, PnmacRowHeader, PnmacText, PnmacMediaQuery, PnmacNavigation, theme, PnmacMeta, PnmacSpinner, PnmacUIButton, PnmacImage, PnmacModal, PnmacPaper, PnmacRow, PnmacTable, PnmacSubheading, PnmacHtmlToNative } from 'pnmac-universal-components';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import styles from '../../styles/styles.js';
import moment from 'moment';
import PendingPayments from '../../components/PendingPayment.js';
import { NACHA_BANKACCOUNT } from '../../redux/actions/actions.js';
import { maskBankInfo, getActiveFeatures, currencyFormatter, genericStatusCheck, paymentsource, accountype, paystatus, RuleId, testID } from '../../utils.js';
import PnmacActivityIndicator from '../../PnmacActivityIndicator';
import BannerView from '../../v2/BannerView';
import { textStyle } from '../../v2/theme';
import RecentPaymentsList from './Platform/RecentPaymentsList.native.js';
import PaymentCard from './Platform/PaymentCard.native.js';
import withPnmacTitle from '../../withPnmacTitle';
import MonthlyPayment from "./MonthlyPayment";
import SetupAutoPay from './SetupAutoPay';
import OneTimePaymentNative from './Platform/OneTimePayment.native.js';
var imageAssets = {
  closeIcon: require('../../assets/icon-close-x-darkGray.png')
};
import { TrackerActionLID_ENUM, TrackerCategoryLID_ENUM, TrackerHitTypeLID_ENUM, UserLanguage_ENUM } from "../../redux/events/events";
var Payment = /** @class */function (_super) {
  __extends(Payment, _super);
  function Payment(props) {
    var _this = _super.call(this, props) || this;
    _this.ineligible = false;
    _this.state = {
      pendingPayments: [],
      pendingPaymentDate: null,
      paymentType: 201299,
      expRef: /*#__PURE__*/React.createRef(),
      canUseDebitCard: true,
      open: false,
      edit: false,
      holdView: false,
      howItWorksModal: false,
      makePayment: false,
      otpConfirmationModal: false,
      isMounted: false
    };
    return _this;
  }
  Payment.prototype.componentDidMount = function () {
    var _this = this;
    if (Platform.OS === 'android' || Platform.OS === 'ios') {
      this.focusSubscription = this.props.navigation.addListener('focus', function () {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        _this.setState(__assign(__assign({}, _this.state), {
          isMounted: true
        }));
        if (_this.ineligible) {
          var label = "Left-Navigation/AutoPay Ineligible|".concat(Platform.OS === 'web' ? 'Web' : 'Mobile');
          Platform.OS === 'web' ? _this.props.trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Button, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, label, 0) : _this.props.trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Button, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, label, -1, "", false);
        }
        if (_this.props.layout.paymentModel && (_this.props.layout.paymentModel.selectedView == undefined || _this.props.layout.paymentModel.selectedView == '')) {
          _this.props.dispatch({
            type: NACHA_BANKACCOUNT,
            paymentModel: __assign(__assign({}, _this.props.layout.paymentModel), {
              selectedView: 'PaymentCard'
            })
          });
        } else if ((_this.props.layout.mobile ? (_b = (_a = _this.props.route) === null || _a === void 0 ? void 0 : _a.params) === null || _b === void 0 ? void 0 : _b.edit : (_d = (_c = _this.props.location) === null || _c === void 0 ? void 0 : _c.state) === null || _d === void 0 ? void 0 : _d.edit) && (_this.props.layout.mobile ? (_f = (_e = _this.props.route) === null || _e === void 0 ? void 0 : _e.params) === null || _f === void 0 ? void 0 : _f.autopayEnabled : (_h = (_g = _this.props.location) === null || _g === void 0 ? void 0 : _g.state) === null || _h === void 0 ? void 0 : _h.autopayEnabled) == undefined) {
          if ((_this.props.layout.paymentModel.selectedView == undefined || _this.props.layout.paymentModel.selectedView == '') && (_this.props.layout.paymentModel.destinationView == undefined || _this.props.layout.paymentModel.destinationView == '')) {
            _this.props.dispatch({
              type: NACHA_BANKACCOUNT,
              paymentModel: __assign(__assign({}, _this.props.layout.paymentModel), {
                selectedView: 'PaymentMethodOneTimePayment',
                destinationView: 'home'
              })
            });
          }
        }
        _this.setState(__assign(__assign({}, _this.state), {
          isMounted: true
        }));
      });
      this.blurSubscription = this.props.navigation.addListener('blur', function (prop) {
        _this.setState(__assign(__assign({}, _this.state), {
          isMounted: false
        }));
        _this.ineligible = false;
      });
    }
  };
  Payment.getDerivedStateFromProps = function (props, state) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12;
    var edit = props.layout.mobile ? (_b = (_a = props.route) === null || _a === void 0 ? void 0 : _a.params) === null || _b === void 0 ? void 0 : _b.edit : (_d = (_c = props.location) === null || _c === void 0 ? void 0 : _c.state) === null || _d === void 0 ? void 0 : _d.edit;
    var modifications = props.layout.modifications;
    var StatusTypeId = modifications === null || modifications === void 0 ? void 0 : modifications.statusTypeId;
    var IsForebearanceOTPVisible = modifications === null || modifications === void 0 ? void 0 : modifications.isForebearanceOTPVisible;
    var forbearacne = StatusTypeId > 0 && IsForebearanceOTPVisible || ((_e = props.layout.currentLoan) === null || _e === void 0 ? void 0 : _e.isLoanInForbearance) || ((_j = (_h = (_g = (_f = props.layout) === null || _f === void 0 ? void 0 : _f.paymentModel) === null || _g === void 0 ? void 0 : _g.loan) === null || _h === void 0 ? void 0 : _h.defaultPayments) === null || _j === void 0 ? void 0 : _j.route) == "Default" && (((_o = (_m = (_l = (_k = props.layout) === null || _k === void 0 ? void 0 : _k.paymentModel) === null || _l === void 0 ? void 0 : _l.loan) === null || _m === void 0 ? void 0 : _m.defaultPayments) === null || _o === void 0 ? void 0 : _o.ruleId) == RuleId.Increased_Payment_Plan || ((_s = (_r = (_q = (_p = props.layout) === null || _p === void 0 ? void 0 : _p.paymentModel) === null || _q === void 0 ? void 0 : _q.loan) === null || _r === void 0 ? void 0 : _r.defaultPayments) === null || _s === void 0 ? void 0 : _s.ruleId) == RuleId.Reduced_Payment_Plan);
    var isTrialPaymentVisible = (modifications === null || modifications === void 0 ? void 0 : modifications.isTrialPaymentVisible) || (modifications === null || modifications === void 0 ? void 0 : modifications.enablePaymentCoupon);
    var show = props.layout.mobile && ((_u = (_t = props.route) === null || _t === void 0 ? void 0 : _t.params) === null || _u === void 0 ? void 0 : _u.isOtp) && !edit && (((_x = (_w = (_v = props.layout) === null || _v === void 0 ? void 0 : _v.paymentModel) === null || _w === void 0 ? void 0 : _w.pendingPayments) === null || _x === void 0 ? void 0 : _x.filter(function (s) {
      return s.paymentType == 201298 || s.paymentType == 201309;
    }).length) > 0 && moment((_y = props.layout.currentLoan) === null || _y === void 0 ? void 0 : _y.nextPaymentDueDate).month() >= moment((_z = props.layout) === null || _z === void 0 ? void 0 : _z.localTime).month() || moment((_0 = props.layout.currentLoan) === null || _0 === void 0 ? void 0 : _0.nextPaymentDueDate) > moment((_1 = props.layout) === null || _1 === void 0 ? void 0 : _1.localTime)) && !isTrialPaymentVisible && !forbearacne && !((_3 = (_2 = props.layout) === null || _2 === void 0 ? void 0 : _2.paymentModel) === null || _3 === void 0 ? void 0 : _3.mustMakeDelinquentPayment);
    if (props.layout.currentLoan != null && props.layout.paymentModel != null && state.pendingPayments != props.layout.paymentModel.pendingPayments) {
      return __assign(__assign({}, state), {
        isMountedBank: true,
        otpConfirmationModal: ((_5 = (_4 = props.route) === null || _4 === void 0 ? void 0 : _4.params) === null || _5 === void 0 ? void 0 : _5.isOtp) && (state === null || state === void 0 ? void 0 : state.isMounted) ? show : false,
        pendingPayments: props.layout.paymentModel.pendingPayments,
        pendingPaymentDate: (_7 = (_6 = props.layout.paymentModel) === null || _6 === void 0 ? void 0 : _6.pendingPayments) === null || _7 === void 0 ? void 0 : _7.find(function (s) {
          return s.paymentType == 201309;
        }),
        canUseDebitCard: (_8 = props.layout.paymentModel) === null || _8 === void 0 ? void 0 : _8.canUseDebitCard,
        edit: edit
      });
    }
    if (state.isMounted && ((_10 = (_9 = props === null || props === void 0 ? void 0 : props.layout) === null || _9 === void 0 ? void 0 : _9.currentLoan) === null || _10 === void 0 ? void 0 : _10.originalNextPaymentDueDate)) {
      return __assign(__assign({}, state), {
        otpConfirmationModal: props.layout.mobile && ((_12 = (_11 = props.route) === null || _11 === void 0 ? void 0 : _11.params) === null || _12 === void 0 ? void 0 : _12.isOtp) ? show : false,
        edit: edit,
        isMounted: false
      });
    }
    return __assign(__assign({}, state), {
      edit: edit
    });
  };
  Payment.prototype.render = function () {
    var _this = this;
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1;
    var _2 = this.props,
      translations = _2.translations,
      layout = _2.layout,
      lamp = _2.lamp,
      route = _2.route;
    var _3 = this.state,
      expRef = _3.expRef,
      edit = _3.edit,
      holdView = _3.holdView,
      pendingPaymentDate = _3.pendingPaymentDate;
    var modifications = layout.modifications,
      currentLoan = layout.currentLoan,
      paymentModel = layout.paymentModel;
    var pendingPayments = (paymentModel || {
      pendingPayments: []
    }).pendingPayments;
    var isOtp = this.props.isOtp;
    if ((_a = route === null || route === void 0 ? void 0 : route.params) === null || _a === void 0 ? void 0 : _a.isOtp) {
      isOtp = true;
    }
    var status = (_b = layout.selectedLoanAvailability) === null || _b === void 0 ? void 0 : _b.status;
    var isModPortalVisible = layout.modPortalVisible;
    var canMakePayment = isOtp ? ((_c = layout === null || layout === void 0 ? void 0 : layout.paymentModel) === null || _c === void 0 ? void 0 : _c.canMakePayment) || holdView || edit || modifications && !modifications.isOTPBlockedForModStatus || modifications && modifications.statusTypeId > 0 && modifications.isForebearanceOTPVisible || (currentLoan === null || currentLoan === void 0 ? void 0 : currentLoan.isLoanInForbearance) : true;
    if (!canMakePayment) {
      this.props.trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Button, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, 'Left-Navigation/OTP- Ineligible|[[platform]]', -1, '', false);
    }
    var trialPendingPaymentCountGreaterThanTwo = ((_d = pendingPayments === null || pendingPayments === void 0 ? void 0 : pendingPayments.filter(function (s) {
      return s.paymentType == 201296;
    })) === null || _d === void 0 ? void 0 : _d.length) >= 2 ? true : false;
    var isadditionalTRInThirtyDaysOfAllTRReceived = (modifications === null || modifications === void 0 ? void 0 : modifications.isLastTPCompletedInThrirtydaysOfCURDate) && ((_e = pendingPayments === null || pendingPayments === void 0 ? void 0 : pendingPayments.filter(function (s) {
      return s.paymentType == 201296;
    })) === null || _e === void 0 ? void 0 : _e.length) == 1 ? true : false;
    var defaultpaymentstatus = ((_h = (_g = (_f = layout === null || layout === void 0 ? void 0 : layout.paymentModel) === null || _f === void 0 ? void 0 : _f.loan) === null || _g === void 0 ? void 0 : _g.defaultPayments) === null || _h === void 0 ? void 0 : _h.route) == RuleId.Default && ((_l = (_k = (_j = layout === null || layout === void 0 ? void 0 : layout.paymentModel) === null || _j === void 0 ? void 0 : _j.loan) === null || _k === void 0 ? void 0 : _k.defaultPayments) === null || _l === void 0 ? void 0 : _l.allowOTD);
    var isPaymentBlockedInLossMit = isOtp ? ((_p = (_o = (_m = layout === null || layout === void 0 ? void 0 : layout.paymentModel) === null || _m === void 0 ? void 0 : _m.loan) === null || _o === void 0 ? void 0 : _o.defaultPayments) === null || _p === void 0 ? void 0 : _p.route) == RuleId.Default || ((_s = (_r = (_q = layout === null || layout === void 0 ? void 0 : layout.paymentModel) === null || _q === void 0 ? void 0 : _q.loan) === null || _r === void 0 ? void 0 : _r.defaultPayments) === null || _s === void 0 ? void 0 : _s.route) == RuleId.Delinquent ? !((_t = layout === null || layout === void 0 ? void 0 : layout.paymentModel) === null || _t === void 0 ? void 0 : _t.canMakePayment) : false : ((_w = (_v = (_u = layout === null || layout === void 0 ? void 0 : layout.paymentModel) === null || _u === void 0 ? void 0 : _u.loan) === null || _v === void 0 ? void 0 : _v.defaultPayments) === null || _w === void 0 ? void 0 : _w.route) == RuleId.Default;
    var achExist = (_y = (_x = layout.paymentModel) === null || _x === void 0 ? void 0 : _x.pendingPayments) === null || _y === void 0 ? void 0 : _y.find(function (s) {
      return s.paymentType == 201309;
    });
    var DATAEXPANDABLE = [isOtp && !lamp ? {
      title: translations === null || translations === void 0 ? void 0 : translations.OtpHowItWorksTitle,
      data: [{
        label: translations === null || translations === void 0 ? void 0 : translations.OtpHowItWorksTitle,
        header: translations === null || translations === void 0 ? void 0 : translations.OtpHowItWorksTitle,
        value: translations === null || translations === void 0 ? void 0 : translations.OtpHowItWorksTitle
      }]
    } : null, {
      title: translations === null || translations === void 0 ? void 0 : translations.OtpPendingPaymentsTitle,
      data: [{
        label: translations === null || translations === void 0 ? void 0 : translations.OtpPendingPaymentsTitle,
        header: translations === null || translations === void 0 ? void 0 : translations.OtpPendingPaymentsTitle,
        value: translations === null || translations === void 0 ? void 0 : translations.OtpPendingPaymentsTitle
      }]
    }, achExist && !isOtp ? {
      title: translations === null || translations === void 0 ? void 0 : translations.AutoPayApplicationSentOn,
      data: []
    } : null, {
      title: translations === null || translations === void 0 ? void 0 : translations.OtpGetStartedTitle,
      data: [{
        label: translations === null || translations === void 0 ? void 0 : translations.OtpGetStartedTitle,
        header: translations === null || translations === void 0 ? void 0 : translations.OtpGetStartedTitle,
        value: translations === null || translations === void 0 ? void 0 : translations.OtpGetStartedTitle
      }]
    }].filter(function (s) {
      return s;
    });
    var noPaymentConent = function (checkAutoPay) {
      var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21, _22, _23, _24, _25, _26, _27, _28, _29, _30, _31, _32, _33, _34, _35, _36, _37, _38, _39, _40;
      if (checkAutoPay === void 0) {
        checkAutoPay = false;
      }
      var value = "Default";
      if (((_a = genericStatusCheck(status, "CompletedTwo", ["Paidinfull"])) === null || _a === void 0 ? void 0 : _a.hasSubStatus) || (currentLoan === null || currentLoan === void 0 ? void 0 : currentLoan.loanStatusCode) == "L") {
        value = "PaidOff";
      }
      if (((_b = genericStatusCheck(status, "CompletedOne", ["ServiceReleased"])) === null || _b === void 0 ? void 0 : _b.hasSubStatus) || (currentLoan === null || currentLoan === void 0 ? void 0 : currentLoan.loanStatusCode) == "S") {
        value = "ServiceReleasePending";
      }
      if (((_c = genericStatusCheck(status, "CompletedOne", ["ChargeoffCompleted"])) === null || _c === void 0 ? void 0 : _c.hasSubStatus) || (currentLoan === null || currentLoan === void 0 ? void 0 : currentLoan.loanStatusCode) == "O") {
        value = "ChargedOff";
      }
      if (((_d = genericStatusCheck(status, "CompletedOne", ["Unfunded"])) === null || _d === void 0 ? void 0 : _d.hasSubStatus) || (currentLoan === null || currentLoan === void 0 ? void 0 : currentLoan.loanStatusCode) == "U") {
        value = "Unfunded";
      }
      if ((_e = genericStatusCheck(status, "DelinquentLiquidation", ["ShortSaleComplete"])) === null || _e === void 0 ? void 0 : _e.hasSubStatus) {
        value = "ShortSaleCompleted";
      }
      if (((_f = genericStatusCheck(status, "DelinquentLiquidation", ["ForeclosureCompleted"])) === null || _f === void 0 ? void 0 : _f.hasSubStatus) && !defaultpaymentstatus) {
        value = "CompletedForeclosure";
      }
      if ((_g = genericStatusCheck(status, "DelinquentLiquidation", ["DeedInLieuCompletedA"])) === null || _g === void 0 ? void 0 : _g.hasSubStatus) {
        value = "DeedInLieuCompleted";
      }
      if (((_h = genericStatusCheck(status, "DelinquentLiquidation", ["REOActive"])) === null || _h === void 0 ? void 0 : _h.hasSubStatus) || ((_j = genericStatusCheck(status, "DelinquentLiquidation", ["REOSaleCompleted"])) === null || _j === void 0 ? void 0 : _j.hasSubStatus) || (currentLoan === null || currentLoan === void 0 ? void 0 : currentLoan.loanStatusCode) == "R") {
        value = "REOActive";
      }
      if ((_k = genericStatusCheck(status, "HHF", ["HHFActivePlan"])) === null || _k === void 0 ? void 0 : _k.hasSubStatus) {
        value = "HardestHitFundsPlan";
      }
      if ((currentLoan === null || currentLoan === void 0 ? void 0 : currentLoan.loanStatusCode) == "F" && (currentLoan === null || currentLoan === void 0 ? void 0 : currentLoan.foreclosureStatus) != "4" && !defaultpaymentstatus) {
        value = "Foreclosure";
      }
      if ((currentLoan === null || currentLoan === void 0 ? void 0 : currentLoan.foreclosureStatus) == "1" && !defaultpaymentstatus) {
        value = "Foreclosure";
      }
      if ((_l = genericStatusCheck(status, "DeedInLieu", ["DeedinLieuActive"])) === null || _l === void 0 ? void 0 : _l.hasSubStatus) {
        value = "DeedinLieuActive";
      }
      if ((_m = genericStatusCheck(status, "ShortSale", ["ShortSaleActive"])) === null || _m === void 0 ? void 0 : _m.hasSubStatus) {
        value = "ShortSaleActive";
      }
      if (status === null || status === void 0 ? void 0 : status.badCheckStop) {
        value = "BadCheckStop";
      }
      if ((currentLoan === null || currentLoan === void 0 ? void 0 : currentLoan.loanStatusCode) == "F" && !defaultpaymentstatus && ((_o = genericStatusCheck(status, "DeedInLieu", ["DeedinLieuActive"])) === null || _o === void 0 ? void 0 : _o.hasSubStatus)) {
        value = "ForeclosureDeedinLieuActive";
      }
      var isTrialPaymentVisible = (modifications === null || modifications === void 0 ? void 0 : modifications.isTrialPaymentVisible) || (modifications === null || modifications === void 0 ? void 0 : modifications.enablePaymentCoupon);
      if (isOtp) {
        // for OTP Blocked  based on Modification Rules
        if ((modifications === null || modifications === void 0 ? void 0 : modifications.statusTypeId) > 0 && (trialPendingPaymentCountGreaterThanTwo || isadditionalTRInThirtyDaysOfAllTRReceived || (modifications === null || modifications === void 0 ? void 0 : modifications.isOTPBlockedForModStatus) && (isTrialPaymentVisible && (modifications === null || modifications === void 0 ? void 0 : modifications.isAllTrailPaymentCompleted) || !isTrialPaymentVisible)) && !(modifications === null || modifications === void 0 ? void 0 : modifications.isForebearanceOTPVisible) && !(currentLoan === null || currentLoan === void 0 ? void 0 : currentLoan.isLoanInForbearance)) {
          value = "Modification";
          if ((currentLoan === null || currentLoan === void 0 ? void 0 : currentLoan.delinquentPaymentCount) > 2) {
            value = "DelinquentModification";
            if ((currentLoan === null || currentLoan === void 0 ? void 0 : currentLoan.loanStatusCode) == "F") {
              value = "DelinquentModificationForeclosure";
            }
          } else if ((currentLoan === null || currentLoan === void 0 ? void 0 : currentLoan.loanStatusCode) == "F") {
            value = "ModificationForeclosure";
          }
        } else if (isOtp && (currentLoan === null || currentLoan === void 0 ? void 0 : currentLoan.delinquentPaymentCount) > (((_q = (_p = paymentModel === null || paymentModel === void 0 ? void 0 : paymentModel.payment) === null || _p === void 0 ? void 0 : _p.delinquentPayments) === null || _q === void 0 ? void 0 : _q.length) > 0 ? 6 : 2) && !isTrialPaymentVisible && !(modifications === null || modifications === void 0 ? void 0 : modifications.isForebearanceOTPVisible) && !(currentLoan === null || currentLoan === void 0 ? void 0 : currentLoan.isLoanInForbearance) && !defaultpaymentstatus && !(((_r = genericStatusCheck(status, "CompletedTwo", ["Paidinfull"])) === null || _r === void 0 ? void 0 : _r.hasSubStatus) || (currentLoan === null || currentLoan === void 0 ? void 0 : currentLoan.loanStatusCode) == "L") && !(((_s = genericStatusCheck(status, "CompletedOne", ["ChargeoffCompleted"])) === null || _s === void 0 ? void 0 : _s.hasSubStatus) || (currentLoan === null || currentLoan === void 0 ? void 0 : currentLoan.loanStatusCode) == "O")) {
          // for OTP Blocked  based on Deliquent and Other Status
          value = "Delinquent";
          if (currentLoan === null || currentLoan === void 0 ? void 0 : currentLoan.isLoanNonDisasterLossMit) {
            value = "LossMitigationNonDisaster";
          }
          if (isModPortalVisible && (modifications === null || modifications === void 0 ? void 0 : modifications.isOTPBlockedForModStatus)) {
            value = "DelinquentModification";
            if ((currentLoan === null || currentLoan === void 0 ? void 0 : currentLoan.loanStatusCode) == "F") {
              value = "DelinquentModificationForeclosure";
            }
          }
          if (status === null || status === void 0 ? void 0 : status.badCheckStop) {
            value = "DelinquentBadCheckStop";
          }
          if ((_t = genericStatusCheck(status, "DelinquentLiquidation", ["DeedInLieuCompleted"])) === null || _t === void 0 ? void 0 : _t.hasSubStatus) {
            value = "DelinquentDeedInLieuCompleted";
          }
          if (((_u = genericStatusCheck(status, "CompletedTwo", ["Paidinfull"])) === null || _u === void 0 ? void 0 : _u.hasSubStatus) || (currentLoan === null || currentLoan === void 0 ? void 0 : currentLoan.loanStatusCode) == "L") {
            value = "DelinquentPaidOff";
          }
          if (((_v = genericStatusCheck(status, "CompletedOne", ["ServiceReleased"])) === null || _v === void 0 ? void 0 : _v.hasSubStatus) || (currentLoan === null || currentLoan === void 0 ? void 0 : currentLoan.loanStatusCode) == "S") {
            value = "DelinquentServiceReleasePending";
          }
          if (((_w = genericStatusCheck(status, "CompletedOne", ["ChargeoffCompleted"])) === null || _w === void 0 ? void 0 : _w.hasSubStatus) || (currentLoan === null || currentLoan === void 0 ? void 0 : currentLoan.loanStatusCode) == "O") {
            value = "DelinquentChargedOff";
          }
          if (((_x = genericStatusCheck(status, "CompletedOne", ["Unfunded"])) === null || _x === void 0 ? void 0 : _x.hasSubStatus) || (currentLoan === null || currentLoan === void 0 ? void 0 : currentLoan.loanStatusCode) == "U") {
            value = "DelinquentUnfunded";
          }
          if ((_y = genericStatusCheck(status, "DelinquentLiquidation", ["ShortSaleComplete"])) === null || _y === void 0 ? void 0 : _y.hasSubStatus) {
            value = "DelinquentShortSaleCompleted";
          }
          if ((_z = genericStatusCheck(status, "DelinquentLiquidation", ["ForeclosureCompleted"])) === null || _z === void 0 ? void 0 : _z.hasSubStatus) {
            value = "DelinquentCompletedForeclosure";
          }
          if ((currentLoan === null || currentLoan === void 0 ? void 0 : currentLoan.loanStatusCode) == "F") {
            value = "DelinquentForeclosure";
          }
          if (((_0 = genericStatusCheck(status, "DelinquentLiquidation", ["REOActive"])) === null || _0 === void 0 ? void 0 : _0.hasSubStatus) || ((_1 = genericStatusCheck(status, "DelinquentLiquidation", ["REOSaleCompleted"])) === null || _1 === void 0 ? void 0 : _1.hasSubStatus) || (currentLoan === null || currentLoan === void 0 ? void 0 : currentLoan.loanStatusCode) == "R") {
            value = "DelinquentREOActive";
          }
          if ((_2 = genericStatusCheck(status, "HHF", ["HHFActivePlan"])) === null || _2 === void 0 ? void 0 : _2.hasSubStatus) {
            value = "DelinquentHardestHitFundsPlan";
          }
          if ((_3 = genericStatusCheck(status, "ShortSale", ["ShortSaleActive"])) === null || _3 === void 0 ? void 0 : _3.hasSubStatus) {
            value = "DelinquentShortSaleActive";
          }
          if ((_4 = genericStatusCheck(status, "DeedInLieu", ["DeedinLieuActive"])) === null || _4 === void 0 ? void 0 : _4.hasSubStatus) {
            value = "DelinquentDeedinLieuActive";
            if ((currentLoan === null || currentLoan === void 0 ? void 0 : currentLoan.loanStatusCode) == "F") {
              value = "DelinquentForeclosureDeedinLieuActive";
            }
          }
          if ((currentLoan === null || currentLoan === void 0 ? void 0 : currentLoan.bankruptcyChapterTypeId) == 1 || (currentLoan === null || currentLoan === void 0 ? void 0 : currentLoan.bankruptcyChapterTypeId) == 2 || (currentLoan === null || currentLoan === void 0 ? void 0 : currentLoan.bankruptcyChapterTypeId) == 3 || (currentLoan === null || currentLoan === void 0 ? void 0 : currentLoan.bankruptcyChapterTypeId) == 4) {
            value = "OTPDeliquentBankruptcyChapter7OR11OR12OR13";
            if ((currentLoan === null || currentLoan === void 0 ? void 0 : currentLoan.loanStatusCode) == "F") {
              value = "OTPDelinquentForeclosureBankruptcyChapter7OR11OR12OR13";
            }
          }
        } else if (isOtp && !isTrialPaymentVisible && !(modifications === null || modifications === void 0 ? void 0 : modifications.isForebearanceOTPVisible) && !(currentLoan === null || currentLoan === void 0 ? void 0 : currentLoan.isLoanInForbearance) && !(((_5 = genericStatusCheck(status, "CompletedTwo", ["Paidinfull"])) === null || _5 === void 0 ? void 0 : _5.hasSubStatus) || (currentLoan === null || currentLoan === void 0 ? void 0 : currentLoan.loanStatusCode) == "L") && !(((_6 = genericStatusCheck(status, "CompletedOne", ["ChargeoffCompleted"])) === null || _6 === void 0 ? void 0 : _6.hasSubStatus) || (currentLoan === null || currentLoan === void 0 ? void 0 : currentLoan.loanStatusCode) == "O")) {
          if (currentLoan === null || currentLoan === void 0 ? void 0 : currentLoan.isLoanNonDisasterLossMit) {
            value = "LossMitigationNonDisaster";
          }
        }
        if (isPaymentBlockedInLossMit == true) {
          value = "Delinquent";
        }
      } else {
        /// for ACH blocked for Loan is in Mod Active OR  TrialPayment OR Foreberance
        if (!isOtp && (modifications === null || modifications === void 0 ? void 0 : modifications.statusTypeId) > 0 && ((modifications === null || modifications === void 0 ? void 0 : modifications.isForebearanceOTPVisible) || isTrialPaymentVisible)) {
          value = "Modification";
          if ((currentLoan === null || currentLoan === void 0 ? void 0 : currentLoan.delinquentPaymentCount) >= 2) {
            value = "DelinquentModification";
            if ((currentLoan === null || currentLoan === void 0 ? void 0 : currentLoan.loanStatusCode) == "F") {
              value = "DelinquentModificationForeclosure";
            }
          } else if ((currentLoan === null || currentLoan === void 0 ? void 0 : currentLoan.loanStatusCode) == "F") {
            value = "ModificationForeclosure";
          }
        } else if (!isOtp && (currentLoan === null || currentLoan === void 0 ? void 0 : currentLoan.delinquentPaymentCount) >= 2 && !(((_7 = genericStatusCheck(status, "CompletedTwo", ["Paidinfull"])) === null || _7 === void 0 ? void 0 : _7.hasSubStatus) || (currentLoan === null || currentLoan === void 0 ? void 0 : currentLoan.loanStatusCode) == "L") && !(((_8 = genericStatusCheck(status, "CompletedOne", ["ChargeoffCompleted"])) === null || _8 === void 0 ? void 0 : _8.hasSubStatus) || (currentLoan === null || currentLoan === void 0 ? void 0 : currentLoan.loanStatusCode) == "O")) {
          // for ACH Blocked  based on Deliquent and Other Status
          value = "Delinquent";
          if (currentLoan === null || currentLoan === void 0 ? void 0 : currentLoan.isLoanNonDisasterLossMit) {
            value = "LossMitigationNonDisaster";
          }
          if (status === null || status === void 0 ? void 0 : status.badCheckStop) {
            value = "DelinquentBadCheckStop";
          }
          if ((_9 = genericStatusCheck(status, "DelinquentLiquidation", ["DeedInLieuCompleted"])) === null || _9 === void 0 ? void 0 : _9.hasSubStatus) {
            value = "DelinquentDeedInLieuCompleted";
          }
          if (((_10 = genericStatusCheck(status, "CompletedTwo", ["Paidinfull"])) === null || _10 === void 0 ? void 0 : _10.hasSubStatus) || (currentLoan === null || currentLoan === void 0 ? void 0 : currentLoan.loanStatusCode) == "L") {
            value = "DelinquentPaidOff";
          }
          if (((_11 = genericStatusCheck(status, "CompletedOne", ["ServiceReleased"])) === null || _11 === void 0 ? void 0 : _11.hasSubStatus) || (currentLoan === null || currentLoan === void 0 ? void 0 : currentLoan.loanStatusCode) == "S") {
            value = "DelinquentServiceReleasePending";
          }
          if (((_12 = genericStatusCheck(status, "CompletedOne", ["ChargeoffCompleted"])) === null || _12 === void 0 ? void 0 : _12.hasSubStatus) || (currentLoan === null || currentLoan === void 0 ? void 0 : currentLoan.loanStatusCode) == "O") {
            value = "DelinquentChargedOff";
          }
          if (((_13 = genericStatusCheck(status, "CompletedOne", ["Unfunded"])) === null || _13 === void 0 ? void 0 : _13.hasSubStatus) || (currentLoan === null || currentLoan === void 0 ? void 0 : currentLoan.loanStatusCode) == "U") {
            value = "DelinquentUnfunded";
          }
          if ((_14 = genericStatusCheck(status, "DelinquentLiquidation", ["ShortSaleComplete"])) === null || _14 === void 0 ? void 0 : _14.hasSubStatus) {
            value = "DelinquentShortSaleCompleted";
          }
          if ((_15 = genericStatusCheck(status, "DelinquentLiquidation", ["ForeclosureCompleted"])) === null || _15 === void 0 ? void 0 : _15.hasSubStatus) {
            value = "DelinquentCompletedForeclosure";
          }
          if (((_16 = genericStatusCheck(status, "DelinquentLiquidation", ["REOActive"])) === null || _16 === void 0 ? void 0 : _16.hasSubStatus) || ((_17 = genericStatusCheck(status, "DelinquentLiquidation", ["REOSaleCompleted"])) === null || _17 === void 0 ? void 0 : _17.hasSubStatus) || (currentLoan === null || currentLoan === void 0 ? void 0 : currentLoan.loanStatusCode) == "R") {
            value = "DelinquentREOActive";
          }
          if ((_18 = genericStatusCheck(status, "HHF", ["HHFActivePlan"])) === null || _18 === void 0 ? void 0 : _18.hasSubStatus) {
            value = "DelinquentHardestHitFundsPlan";
          }
          if ((_19 = genericStatusCheck(status, "ServiceReleasePending", ["ServiceReleasePending"])) === null || _19 === void 0 ? void 0 : _19.hasSubStatus) {
            value = "DelinquentServiceReleasePending";
          }
          if ((_20 = genericStatusCheck(status, "ShortSale", ["ShortSaleActive"])) === null || _20 === void 0 ? void 0 : _20.hasSubStatus) {
            value = "DelinquentShortSaleActive";
          }
          if ((currentLoan === null || currentLoan === void 0 ? void 0 : currentLoan.loanStatusCode) == "F") {
            value = "DelinquentForeclosure";
          }
          if ((_21 = genericStatusCheck(status, "DeedInLieu", ["DeedinLieuActive"])) === null || _21 === void 0 ? void 0 : _21.hasSubStatus) {
            value = "DelinquentDeedinLieuActive";
            if ((currentLoan === null || currentLoan === void 0 ? void 0 : currentLoan.loanStatusCode) == "F") {
              value = "DelinquentForeclosureDeedinLieuActive";
            }
          }
          if ((currentLoan === null || currentLoan === void 0 ? void 0 : currentLoan.bankruptcyChapterTypeId) == 1 || (currentLoan === null || currentLoan === void 0 ? void 0 : currentLoan.bankruptcyChapterTypeId) == 2 || (currentLoan === null || currentLoan === void 0 ? void 0 : currentLoan.bankruptcyChapterTypeId) == 3) {
            value = "ACHDeliquentBankruptcyChapter7OR11OR12";
            if ((currentLoan === null || currentLoan === void 0 ? void 0 : currentLoan.loanStatusCode) == "F") {
              value = "ACHDelinquentForeclosureBankruptcyChapter7OR11OR12";
            }
          }
          if ((currentLoan === null || currentLoan === void 0 ? void 0 : currentLoan.bankruptcyChapterTypeId) == 4) {
            value = "ACHDeliquentBankruptcyChapter13";
            if ((currentLoan === null || currentLoan === void 0 ? void 0 : currentLoan.loanStatusCode) == "F") {
              value = "ACHDelinquentForeclosureBankruptcyChapter13";
            }
          }
        } else if (!isOtp && !(((_22 = genericStatusCheck(status, "CompletedTwo", ["Paidinfull"])) === null || _22 === void 0 ? void 0 : _22.hasSubStatus) || (currentLoan === null || currentLoan === void 0 ? void 0 : currentLoan.loanStatusCode) == "L") && !(((_23 = genericStatusCheck(status, "CompletedOne", ["ChargeoffCompleted"])) === null || _23 === void 0 ? void 0 : _23.hasSubStatus) || (currentLoan === null || currentLoan === void 0 ? void 0 : currentLoan.loanStatusCode) == "O")) {
          if (currentLoan === null || currentLoan === void 0 ? void 0 : currentLoan.isLoanNonDisasterLossMit) {
            value = "LossMitigationNonDisaster";
          }
        }
        if (isPaymentBlockedInLossMit == true) {
          value = "Delinquent";
        }
      }
      if (checkAutoPay) {
        value = '';
        if ((modifications === null || modifications === void 0 ? void 0 : modifications.statusTypeId) > 0 && ((modifications === null || modifications === void 0 ? void 0 : modifications.isForebearanceOTPVisible) || (modifications === null || modifications === void 0 ? void 0 : modifications.isTrialPaymentVisible))) {
          value = "Modification";
          if ((currentLoan === null || currentLoan === void 0 ? void 0 : currentLoan.delinquentPaymentCount) >= 2) {
            value = "DelinquentModification";
            if ((currentLoan === null || currentLoan === void 0 ? void 0 : currentLoan.loanStatusCode) == "F") {
              value = "DelinquentModificationForeclosure";
            }
          } else if ((currentLoan === null || currentLoan === void 0 ? void 0 : currentLoan.loanStatusCode) == "F") {
            value = "ModificationForeclosure";
          }
        } else if ((currentLoan === null || currentLoan === void 0 ? void 0 : currentLoan.delinquentPaymentCount) >= 2 && !(((_24 = genericStatusCheck(status, "CompletedTwo", ["Paidinfull"])) === null || _24 === void 0 ? void 0 : _24.hasSubStatus) || (currentLoan === null || currentLoan === void 0 ? void 0 : currentLoan.loanStatusCode) == "L") && !(((_25 = genericStatusCheck(status, "CompletedOne", ["ChargeoffCompleted"])) === null || _25 === void 0 ? void 0 : _25.hasSubStatus) || (currentLoan === null || currentLoan === void 0 ? void 0 : currentLoan.loanStatusCode) == "O")) {
          // for ACH Blocked  based on Deliquent and Other Status
          value = "Delinquent";
          if (currentLoan === null || currentLoan === void 0 ? void 0 : currentLoan.isLoanNonDisasterLossMit) {
            value = "LossMitigationNonDisaster";
          }
          if (status === null || status === void 0 ? void 0 : status.badCheckStop) {
            value = "DelinquentBadCheckStop";
          }
          if ((_26 = genericStatusCheck(status, "DelinquentLiquidation", ["DeedInLieuCompleted"])) === null || _26 === void 0 ? void 0 : _26.hasSubStatus) {
            value = "DelinquentDeedInLieuCompleted";
          }
          if (((_27 = genericStatusCheck(status, "CompletedTwo", ["Paidinfull"])) === null || _27 === void 0 ? void 0 : _27.hasSubStatus) || (currentLoan === null || currentLoan === void 0 ? void 0 : currentLoan.loanStatusCode) == "L") {
            value = "DelinquentPaidOff";
          }
          if (((_28 = genericStatusCheck(status, "CompletedOne", ["ServiceReleased"])) === null || _28 === void 0 ? void 0 : _28.hasSubStatus) || (currentLoan === null || currentLoan === void 0 ? void 0 : currentLoan.loanStatusCode) == "S") {
            value = "DelinquentServiceReleasePending";
          }
          if (((_29 = genericStatusCheck(status, "CompletedOne", ["ChargeoffCompleted"])) === null || _29 === void 0 ? void 0 : _29.hasSubStatus) || (currentLoan === null || currentLoan === void 0 ? void 0 : currentLoan.loanStatusCode) == "O") {
            value = "DelinquentChargedOff";
          }
          if (((_30 = genericStatusCheck(status, "CompletedOne", ["Unfunded"])) === null || _30 === void 0 ? void 0 : _30.hasSubStatus) || (currentLoan === null || currentLoan === void 0 ? void 0 : currentLoan.loanStatusCode) == "U") {
            value = "DelinquentUnfunded";
          }
          if ((_31 = genericStatusCheck(status, "DelinquentLiquidation", ["ShortSaleComplete"])) === null || _31 === void 0 ? void 0 : _31.hasSubStatus) {
            value = "DelinquentShortSaleCompleted";
          }
          if ((_32 = genericStatusCheck(status, "DelinquentLiquidation", ["ForeclosureCompleted"])) === null || _32 === void 0 ? void 0 : _32.hasSubStatus) {
            value = "DelinquentCompletedForeclosure";
          }
          if (((_33 = genericStatusCheck(status, "DelinquentLiquidation", ["REOActive"])) === null || _33 === void 0 ? void 0 : _33.hasSubStatus) || ((_34 = genericStatusCheck(status, "DelinquentLiquidation", ["REOSaleCompleted"])) === null || _34 === void 0 ? void 0 : _34.hasSubStatus) || (currentLoan === null || currentLoan === void 0 ? void 0 : currentLoan.loanStatusCode) == "R") {
            value = "DelinquentREOActive";
          }
          if ((_35 = genericStatusCheck(status, "HHF", ["HHFActivePlan"])) === null || _35 === void 0 ? void 0 : _35.hasSubStatus) {
            value = "DelinquentHardestHitFundsPlan";
          }
          if ((_36 = genericStatusCheck(status, "ServiceReleasePending", ["ServiceReleasePending"])) === null || _36 === void 0 ? void 0 : _36.hasSubStatus) {
            value = "DelinquentServiceReleasePending";
          }
          if ((_37 = genericStatusCheck(status, "ShortSale", ["ShortSaleActive"])) === null || _37 === void 0 ? void 0 : _37.hasSubStatus) {
            value = "DelinquentShortSaleActive";
          }
          if ((currentLoan === null || currentLoan === void 0 ? void 0 : currentLoan.loanStatusCode) == "F") {
            value = "DelinquentForeclosure";
          }
          if ((_38 = genericStatusCheck(status, "DeedInLieu", ["DeedinLieuActive"])) === null || _38 === void 0 ? void 0 : _38.hasSubStatus) {
            value = "DelinquentDeedinLieuActive";
            if ((currentLoan === null || currentLoan === void 0 ? void 0 : currentLoan.loanStatusCode) == "F") {
              value = "DelinquentForeclosureDeedinLieuActive";
            }
          }
          if ((currentLoan === null || currentLoan === void 0 ? void 0 : currentLoan.bankruptcyChapterTypeId) == 1 || (currentLoan === null || currentLoan === void 0 ? void 0 : currentLoan.bankruptcyChapterTypeId) == 2 || (currentLoan === null || currentLoan === void 0 ? void 0 : currentLoan.bankruptcyChapterTypeId) == 3) {
            value = "ACHDeliquentBankruptcyChapter7OR11OR12";
            if ((currentLoan === null || currentLoan === void 0 ? void 0 : currentLoan.loanStatusCode) == "F") {
              value = "ACHDelinquentForeclosureBankruptcyChapter7OR11OR12";
            }
          }
          if ((currentLoan === null || currentLoan === void 0 ? void 0 : currentLoan.bankruptcyChapterTypeId) == 4) {
            value = "ACHDeliquentBankruptcyChapter13";
            if ((currentLoan === null || currentLoan === void 0 ? void 0 : currentLoan.loanStatusCode) == "F") {
              value = "ACHDelinquentForeclosureBankruptcyChapter13";
            }
          }
        } else if (!(((_39 = genericStatusCheck(status, "CompletedTwo", ["Paidinfull"])) === null || _39 === void 0 ? void 0 : _39.hasSubStatus) || (currentLoan === null || currentLoan === void 0 ? void 0 : currentLoan.loanStatusCode) == "L") && !(((_40 = genericStatusCheck(status, "CompletedOne", ["ChargeoffCompleted"])) === null || _40 === void 0 ? void 0 : _40.hasSubStatus) || (currentLoan === null || currentLoan === void 0 ? void 0 : currentLoan.loanStatusCode) == "O")) {
          if (currentLoan === null || currentLoan === void 0 ? void 0 : currentLoan.isLoanNonDisasterLossMit) {
            value = "LossMitigationNonDisaster";
          }
        }
        if (isPaymentBlockedInLossMit == true) {
          value = "Delinquent";
        }
        return value ? true : false;
      }
      return {
        PaidOff: [translations.PaidOff],
        ServiceReleasePending: [translations.ServiceReleased],
        CompletedForeclosure: [translations.CompletedForeclosure],
        ShortSaleActive: [translations.ShortSaleActive],
        ShortSaleCompleted: [translations.ShortSaleCompleted],
        Foreclosure: [translations.Foreclosure],
        DeedInLieuActive: [translations.DeedInLieuActive],
        ChargedOff: [translations.ChargedOff],
        Unfunded: [translations.Unfunded],
        Delinquent: [translations.Delinquent],
        LossMitigationNonDisaster: [translations.LossMitNonDisasterLoan],
        HardestHitFundsPlan: [translations.HardestHitFundsPlan],
        LossMitigation: [translations.PaidOff],
        DeedInLieuCompleted: [translations.DeedInLieuCompleted],
        BadCheckStop: [translations.BadCheckStop],
        REOActive: [translations.Reo, translations.CompletedForeclosure],
        Modification: [translations.Modification],
        ForeclosureDeedinLieuActive: [translations.Foreclosure, translations.DeedInLieuActive],
        DelinquentBadCheckStop: [translations.Delinquent, translations.BadCheckStop],
        DelinquentDeedinLieuActive: [translations.Delinquent, translations.DeedInLieuActive],
        DelinquentForeclosure: [translations.Delinquent, translations.Foreclosure],
        DelinquentForeclosureDeedinLieuActive: [translations.Delinquent, translations.Foreclosure, translations.DeedInLieuActive],
        ModificationForeclosure: [translations.Foreclosure, translations.Modification],
        DeliquentBankruptcy: [translations.Foreclosure],
        DelinquentModification: [translations.Delinquent, translations.Modification],
        DelinquentModificationForeclosure: [translations.Delinquent, translations.Modification, translations.Foreclosure],
        OTPDeliquentBankruptcyChapter7OR11OR12OR13: [translations.Delinquent],
        ACHDeliquentBankruptcyChapter7OR11OR12: [translations.Delinquent],
        ACHDeliquentBankruptcyChapter13: [translations.BankruptcyChapter13],
        DelinquentDeedInLieuCompleted: [translations.Delinquent, translations.DeedInLieuCompleted],
        DelinquentPaidOff: [translations.Delinquent, translations.PaidOff],
        DelinquentServiceReleasePending: [translations.Delinquent, translations.ServiceReleased],
        DelinquentChargedOff: [translations.Delinquent, translations.ChargedOff],
        DelinquentUnfunded: [translations.Delinquent, translations.Unfunded],
        DelinquentShortSaleCompleted: [translations.Delinquent, translations.ShortSaleCompleted],
        DelinquentCompletedForeclosure: [translations.Delinquent, translations.CompletedForeclosure],
        DelinquentREOActive: [translations.Delinquent, translations.Reo, translations.CompletedForeclosure],
        DelinquentHardestHitFundsPlan: [translations.Delinquent, translations.HardestHitFundsPlan],
        DelinquentLossMitigation: [translations.Delinquent, translations.PaidOff],
        DelinquentShortSaleActive: [translations.Delinquent, translations.ShortSaleActive],
        OTPDelinquentForeclosureBankruptcyChapter7OR11OR12OR13: [translations.Delinquent, translations.Foreclosure],
        ACHDelinquentForeclosureBankruptcyChapter7OR11OR12: [translations.Delinquent, translations.Foreclosure],
        ACHDelinquentForeclosureBankruptcyChapter13: [translations.BankruptcyChapter13, translations.Foreclosure]
      }[value] || [];
    };
    var isTrialPaymentVisible = (modifications === null || modifications === void 0 ? void 0 : modifications.isTrialPaymentVisible) || (modifications === null || modifications === void 0 ? void 0 : modifications.enablePaymentCoupon);
    this.ineligible = !holdView && !edit && ((_z = noPaymentConent()) === null || _z === void 0 ? void 0 : _z.length) > 0 && !isOtp && ((modifications === null || modifications === void 0 ? void 0 : modifications.statusTypeId) > 0 && ((modifications === null || modifications === void 0 ? void 0 : modifications.isForebearanceOTPVisible) || isTrialPaymentVisible) || !(modifications === null || modifications === void 0 ? void 0 : modifications.isForebearanceOTPVisible));
    var activityHistory = ((_0 = layout.currentLoanActivity) === null || _0 === void 0 ? void 0 : _0.history.filter(function (value) {
      return value.transactionCodeDesc === 'Payment';
    })) || [];
    if (isOtp && !((_1 = layout === null || layout === void 0 ? void 0 : layout.currentLoan) === null || _1 === void 0 ? void 0 : _1.originalNextPaymentDueDate) && this.props.layout.mobile) {
      return /*#__PURE__*/React.createElement(View, {
        style: {
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          alignItems: "center",
          marginTop: 50,
          marginBottom: 50
        }
      }, /*#__PURE__*/React.createElement(PnmacActivityIndicator, null));
    }
    var timingContent = [translations.Same_dayPayments, translations.Paymentsscheduled, translations.Payments_latefees, translations.PaymentsSufficientfunds];
    var verficationContent = [translations.Paymenst_businees_days, translations.paymentsbanlaccount, translations.Bankaccountmeessagecenter, translations.Payementsinvalidbankaccount];
    var renderDisclaimer = function (content) {
      return /*#__PURE__*/React.createElement(View, {
        style: {
          flexDirection: 'row',
          alignItems: 'flex-start',
          marginBottom: 10
        }
      }, /*#__PURE__*/React.createElement(PnmacText, {
        style: {
          color: '#5C5C5C'
        }
      }, "\u2022", ' '), /*#__PURE__*/React.createElement(PnmacHtmlToNative, {
        value: content
      }));
    };
    return /*#__PURE__*/React.createElement(PnmacMediaQuery, {
      onRefresh: function () {
        _this.props.authenticate(false);
      },
      refreshing: layout.reloadingData,
      queries: {
        small: "(max-width: 599px)",
        medium: "(min-width: 600px) and (max-width: 1199px)",
        large: "(min-width: 1200px)"
      }
    }, function (matches) {
      var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s;
      return /*#__PURE__*/React.createElement(View, {
        id: "main-content",
        style: {
          paddingHorizontal: 10
        }
      }, /*#__PURE__*/React.createElement(PnmacMeta, {
        title: isOtp ? translations.OtpPageTitle : translations.automaticPayments
      }), /*#__PURE__*/React.createElement(View, {
        className: "row"
      }, ((_a = layout === null || layout === void 0 ? void 0 : layout.currentLoan) === null || _a === void 0 ? void 0 : _a.helocFlag) ? /*#__PURE__*/React.createElement(BannerView, null, /*#__PURE__*/React.createElement(BannerView.Text, {
        nativeID: 'txtHelocVerbiage'
      }, translations.HelocVerbiage)) : !holdView && !edit && ((_b = noPaymentConent()) === null || _b === void 0 ? void 0 : _b.length) > 0 && (isOtp && (isTrialPaymentVisible && (modifications === null || modifications === void 0 ? void 0 : modifications.isAllTrailPaymentCompleted) || !isTrialPaymentVisible || trialPendingPaymentCountGreaterThanTwo || isadditionalTRInThirtyDaysOfAllTRReceived || (modifications === null || modifications === void 0 ? void 0 : modifications.isOTPBlockedForModStatus)) && !(modifications === null || modifications === void 0 ? void 0 : modifications.isForebearanceOTPVisible) && ((currentLoan === null || currentLoan === void 0 ? void 0 : currentLoan.loanStatusCode) == "F" && (currentLoan === null || currentLoan === void 0 ? void 0 : currentLoan.isLoanInForbearance) || !(currentLoan === null || currentLoan === void 0 ? void 0 : currentLoan.isLoanInForbearance)) || !isOtp && ((modifications === null || modifications === void 0 ? void 0 : modifications.statusTypeId) > 0 && ((modifications === null || modifications === void 0 ? void 0 : modifications.isForebearanceOTPVisible) || isTrialPaymentVisible) || !(modifications === null || modifications === void 0 ? void 0 : modifications.isForebearanceOTPVisible)) || isOtp && (currentLoan === null || currentLoan === void 0 ? void 0 : currentLoan.foreclosureStatus) == "1") || isPaymentBlockedInLossMit == true ? /*#__PURE__*/React.createElement(BannerView, {
        type: 'warning'
      }, /*#__PURE__*/React.createElement(BannerView.Text, {
        nativeID: 'lblFeatureUnavailableMessage'
      }, isOtp ? translations.FeatureUnavailableMessage + ' ' : translations.FeatureUnavailableMessageAutoPay + ' ', /*#__PURE__*/React.createElement(Text, {
        style: textStyle.clickableLink,
        onPress: function () {
          return PnmacNavigation(__assign({
            action: {
              pathname: "/Home/Contact"
            }
          }, _this.props));
        }
      }, translations.ContactUs), "."), /*#__PURE__*/React.createElement(BannerView.Text, {
        nativeId: 'lblReasonForACHOtpUnavailable'
      }, '\n', isOtp ? translations.ReasonForOtpUnavailable : translations.ReasonForAchUnavailable), /*#__PURE__*/React.createElement(View, {
        style: {
          paddingTop: 10
        },
        id: "ulReasons"
      }, (_c = noPaymentConent()) === null || _c === void 0 ? void 0 : _c.map(function (s, i) {
        return /*#__PURE__*/React.createElement(View, {
          style: {
            marginLeft: 10,
            marginBottom: 5
          },
          key: i
        }, /*#__PURE__*/React.createElement(BannerView.Text, {
          key: i
        }, "\u2022 ", s));
      }))) : !isOtp && _this.props.layout.mobile && getActiveFeatures(layout.features, "Payment_Autopay", false) ? /*#__PURE__*/React.createElement(SetupAutoPay, __assign({
        holdViewOpen: function () {
          _this.setState({
            holdView: true
          });
        },
        route: route,
        editPendingPayment: edit,
        isOtp: isOtp,
        disableDebit: function (can) {
          _this.setState({
            canUseDebitCard: can || false
          });
        },
        paymentType: function (data) {
          return _this.setState({
            paymentType: data
          });
        },
        matches: matches
      }, _this.props)) : canMakePayment && layout.paymentModel && !((_d = route === null || route === void 0 ? void 0 : route.params) === null || _d === void 0 ? void 0 : _d.makePayment) && _this.props.layout.mobile && isOtp && getActiveFeatures(layout.features, "view_one_time_payment_methods", false) && !edit ? (/*#__PURE__*/React.createElement(View, null, isOtp && /*#__PURE__*/React.createElement(View, {
        style: activityHistory.length > 4 && {
          marginVertical: 10
        }
      }, activityHistory.length < 5 && /*#__PURE__*/React.createElement(PnmacPaper, {
        style: styles.newToPaymentsContainer
      }, /*#__PURE__*/React.createElement(PnmacText, {
        style: styles.newToPaymentsText
      }, translations.know_important_details, ' ', /*#__PURE__*/React.createElement(Text, {
        style: styles.seeHowItWorksText,
        onPress: function () {
          _this.props.trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Button, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, 'OTP/Minicard|Mobile', -1, "", false);
          _this.setState({
            howItWorksModal: true
          });
        }
      }, translations.LearnHowitworks, '>')))), /*#__PURE__*/React.createElement(PaymentCard, {
        navigation: _this.props.navigation,
        achExist: achExist,
        layout: layout,
        props: _this.props,
        navigateToOTP: function () {
          _this.props.dispatch({
            type: NACHA_BANKACCOUNT,
            paymentModel: __assign(__assign({}, _this.props.layout.paymentModel), {
              selectedView: 'PaymentMethodOneTimePayment',
              destinationView: '',
              homeView: false
            })
          }, _this.props.navigation.navigate("Payment", {
            isOtp: true,
            makePayment: true
          }));
        },
        isInEligible: noPaymentConent(true),
        paymentValue: currencyFormatter('en-US', 'currency', 'USD', (_f = (_e = layout.paymentModel) === null || _e === void 0 ? void 0 : _e.payment) === null || _f === void 0 ? void 0 : _f.totalDraftAmount),
        paymentDue: (_j = moment(achExist ? pendingPaymentDate === null || pendingPaymentDate === void 0 ? void 0 : pendingPaymentDate.effectiveDate : (_h = (_g = layout.paymentModel) === null || _g === void 0 ? void 0 : _g.payment) === null || _h === void 0 ? void 0 : _h.dueDate)) === null || _j === void 0 ? void 0 : _j.format("MM/DD/YYYY"),
        dueDateDisclaimer: moment(currentLoan.lateChargeGraceEndDate).format("MM/DD/YYYY"),
        disclaimerFee: currencyFormatter('en-US', 'currency', 'USD', currentLoan.quotedLateChargeFeeAmount)
      }), !achExist && !noPaymentConent(true) && /*#__PURE__*/React.createElement(TouchableOpacity, {
        onPress: function () {
          _this.props.navigation.navigate("Payment/Ach", {
            edit: false
          });
          _this.props.dispatch({
            type: NACHA_BANKACCOUNT,
            paymentModel: __assign(__assign({}, _this.props.layout.paymentModel), {
              selectedView: 'Autopay'
            })
          });
          var label = Platform.OS == 'web' ? "OTP-page/AutoPay link|Web" : "OTP-page/AutoPay link|Mobile";
          Platform.OS == 'web' ? _this.props.trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Button, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, label, 0) : _this.props.trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Button, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, label, -1, "", false);
        }
      }, /*#__PURE__*/React.createElement(BannerView, {
        style: styles.saveTimeContainer
      }, PnmacImage("dollarSign", 25, "Dollar Sign", 'xml'), /*#__PURE__*/React.createElement(View, {
        style: {
          marginLeft: 6,
          flex: 1
        }
      }, /*#__PURE__*/React.createElement(PnmacText, {
        style: styles.saveTimeTitle
      }, translations.SaveTimeAutoPay), /*#__PURE__*/React.createElement(PnmacText, {
        style: styles.saveTimeSubtitle
      }, translations.SaveTimeAutoPayDisclaimer)))), isOtp && activityHistory.length > 4 && /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(PnmacPaper, {
        style: styles.newToPaymentsContainer
      }, /*#__PURE__*/React.createElement(PnmacText, {
        style: styles.newToPaymentsText
      }, translations.know_important_details, " ", /*#__PURE__*/React.createElement(Text, __assign({
        style: styles.seeHowItWorksText
      }, testID('LearnHowitworks'), {
        onPress: function () {
          _this.props.trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Button, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, 'OTP/Minicard|Mobile', -1, "", false);
          _this.setState({
            howItWorksModal: true
          });
        }
      }), translations.LearnHowitworks, '>')))), /*#__PURE__*/React.createElement(View, {
        style: isOtp && activityHistory.length < 5 && {
          marginTop: 19.9
        }
      }, /*#__PURE__*/React.createElement(RecentPaymentsList, {
        navigation: _this.props.navigation
      })))) : canMakePayment && layout.paymentModel ? /*#__PURE__*/React.createElement(View, null, _this.props.layout.mobile && isOtp && getActiveFeatures(layout.features, "view_one_time_payment_methods", false) == true ? /*#__PURE__*/React.createElement(OneTimePaymentNative, __assign({
        holdViewOpen: function () {
          _this.setState({
            holdView: true
          });
        },
        route: route,
        editPendingPayment: edit,
        isOtp: isOtp,
        disableDebit: function (can) {
          _this.setState({
            canUseDebitCard: can || false
          });
        },
        paymentType: function (data) {
          return _this.setState({
            paymentType: data
          });
        },
        matches: matches
      }, _this.props)) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(BannerView, {
        style: {
          marginBottom: Platform.OS === 'web' ? 10 : undefined
        }
      }, /*#__PURE__*/React.createElement(BannerView.Text, null, _this.state.canUseDebitCard ? translations.OtpDescriptionWithDebit : translations.OtpDescription)), /*#__PURE__*/React.createElement(PnmacSectionListView, {
        idTag1: 'listViewHowItWorks',
        openDefaults: edit || layout.mobile ? [(_l = (_k = _this.props) === null || _k === void 0 ? void 0 : _k.translations) === null || _l === void 0 ? void 0 : _l.OtpGetStartedTitle] : [(_o = (_m = _this.props) === null || _m === void 0 ? void 0 : _m.translations) === null || _o === void 0 ? void 0 : _o.OtpPendingPaymentsTitle, (_q = (_p = _this.props) === null || _p === void 0 ? void 0 : _p.translations) === null || _q === void 0 ? void 0 : _q.OtpGetStartedTitle],
        ref: expRef,
        data: DATAEXPANDABLE,
        collapsableSections: true,
        renderItem: function (_a, collapsed) {
          var _b, _c, _d, _e, _f, _g;
          var item = _a.item;
          if (collapsed.some(function (s) {
            return s == item.header;
          })) {
            if (item.header == (translations === null || translations === void 0 ? void 0 : translations.OtpHowItWorksTitle)) {
              if (getActiveFeatures(layout.features, "View_NACHA", false)) {
                return /*#__PURE__*/React.createElement(View, {
                  style: __assign({}, styles.oneTimePayment.sectionListContainer)
                }, /*#__PURE__*/React.createElement(View, {
                  style: {
                    flex: 1,
                    flexDirection: "column",
                    paddingTop: 15,
                    paddingLeft: 10
                  }
                }, /*#__PURE__*/React.createElement(PnmacText, {
                  style: textStyle.formBody
                }, translations.Payementsone_timepayments), /*#__PURE__*/React.createElement(PnmacText, {
                  style: textStyle.formBody
                }, translations.Timing), /*#__PURE__*/React.createElement("ul", null, /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(PnmacText, {
                  style: textStyle.formBody
                }, translations.Same_dayPayments)), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(PnmacText, {
                  style: textStyle.formBody
                }, translations.Paymentsscheduled)), /*#__PURE__*/React.createElement("li", null, " ", /*#__PURE__*/React.createElement(PnmacText, {
                  style: textStyle.formBody
                }, translations.Payments_latefees)), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(PnmacText, {
                  style: textStyle.formBody
                }, translations.PaymentsSufficientfunds))), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(PnmacText, {
                  style: textStyle.formBody
                }, translations.BankAccountVerification), /*#__PURE__*/React.createElement("ul", null, /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(PnmacHtmlToNative, {
                  value: translations.Paymenst_businees_days
                })), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(PnmacText, {
                  style: textStyle.formBody
                }, translations.paymentsbanlaccount), " "), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(PnmacText, {
                  style: textStyle.formBody
                }, translations.Bankaccountmeessagecenter), " "), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(PnmacText, {
                  style: textStyle.formBody
                }, translations.Payementsinvalidbankaccount), " "))));
              } else {
                return /*#__PURE__*/React.createElement(View, {
                  style: __assign({}, styles.oneTimePayment.sectionListContainer)
                }, /*#__PURE__*/React.createElement(PnmacSubheading, {
                  style: textStyle.defaultTextTitle
                }, translations === null || translations === void 0 ? void 0 : translations.OtpHowItWorksDesc), true ? /*#__PURE__*/React.createElement(View, {
                  style: {
                    paddingTop: 15,
                    paddingLeft: 10
                  }
                }, /*#__PURE__*/React.createElement(PnmacText, {
                  style: textStyle.formBody
                }, "\u2022 ", translations.OtpHELOCHowItWorksGuideline1), /*#__PURE__*/React.createElement(PnmacText, {
                  style: textStyle.formBody
                }, "\u2022 ", translations.OtpHELOCHowItWorksGuideline2), /*#__PURE__*/React.createElement(PnmacText, {
                  style: textStyle.formBody
                }, "\u2022 ", translations.OtpHELOCHowItWorksGuideline3)) : /*#__PURE__*/React.createElement(View, {
                  style: {
                    paddingTop: 15,
                    paddingLeft: 10
                  }
                }, /*#__PURE__*/React.createElement(PnmacText, {
                  style: textStyle.formBody
                }, "\u2022 ", translations.OtpHowItWorksGuideline1), /*#__PURE__*/React.createElement(PnmacText, {
                  style: textStyle.formBody
                }, "\u2022 ", translations.OtpHowItWorksGuideline2), /*#__PURE__*/React.createElement(PnmacText, {
                  style: textStyle.formBody
                }, "\u2022 ", translations.OtpHowItWorksGuideline3), /*#__PURE__*/React.createElement(PnmacText, {
                  style: textStyle.formBody
                }, "\u2022 ", translations.OtpHowItWorksGuideline4), /*#__PURE__*/React.createElement(PnmacText, {
                  style: textStyle.formBody
                }, "\u2022 ", translations.OtpHowItWorksGuideline5)));
              }
            } else if (item.header == (translations === null || translations === void 0 ? void 0 : translations.OtpPendingPaymentsTitle)) {
              return !(pendingPayments === null || pendingPayments === void 0 ? void 0 : pendingPayments.length) ? /*#__PURE__*/React.createElement(View, {
                style: __assign({}, styles.oneTimePayment.sectionListContainer)
              }, /*#__PURE__*/React.createElement(PnmacText, {
                idTag1: 'lblPendingPaymentsMessage'
              }, "You do not currently have any pending payments.")) : matches.small ? /*#__PURE__*/React.createElement(PendingPayments, __assign({
                pendingPayments: (pendingPayments === null || pendingPayments === void 0 ? void 0 : pendingPayments.filter(function (g) {
                  return g.loanId == layout.selectedLoanNumber;
                })) || []
              }, _this.props)) : /*#__PURE__*/React.createElement(View, {
                style: __assign({}, styles.oneTimePayment.sectionListContainer)
              }, /*#__PURE__*/React.createElement(PnmacTable, {
                style: __assign({
                  backgroundColor: "#FFF",
                  borderRadius: 10
                }, styles.shadowStyles),
                borderStyle: {
                  borderColor: "#EFEFEF"
                }
              }, /*#__PURE__*/React.createElement(PnmacRow, {
                flexArr: [3, 2, 2, 2, 3, 3, 2],
                noBorder: true,
                data: [/*#__PURE__*/React.createElement(PnmacText, {
                  style: [textStyle.formBody, {
                    paddingRight: matches.small ? 5 : 10
                  }]
                }, "Source"), /*#__PURE__*/React.createElement(PnmacText, {
                  style: [textStyle.formBody, {
                    paddingRight: matches.small ? 5 : 10
                  }]
                }, "Amount"), /*#__PURE__*/React.createElement(PnmacText, {
                  style: [textStyle.formBody, {
                    paddingRight: matches.small ? 5 : 10
                  }]
                }, "Account Type"), /*#__PURE__*/React.createElement(PnmacText, {
                  style: [textStyle.formBody, {
                    paddingRight: matches.small ? 5 : 10
                  }]
                }, "Bank Account"), /*#__PURE__*/React.createElement(PnmacText, {
                  style: [textStyle.formBody, {
                    paddingRight: matches.small ? 5 : 10
                  }]
                }, "Payment Effective Date"), /*#__PURE__*/React.createElement(PnmacText, {
                  style: [textStyle.formBody, {
                    paddingRight: matches.small ? 5 : 10
                  }]
                }, "Payment Confirmation Code"), /*#__PURE__*/React.createElement(PnmacText, {
                  style: [textStyle.formBody, {
                    paddingRight: matches.small ? 5 : 10
                  }]
                }, "Status")],
                style: {
                  padding: matches.small ? 0 : 10,
                  paddingLeft: matches.small ? 5 : 10,
                  backgroundColor: "#EFEFEF",
                  height: "auto",
                  borderTopLeftRadius: 10,
                  borderTopRightRadius: 10
                },
                textStyle: {
                  padding: matches.small ? 5 : 0,
                  paddingRight: matches.small ? 5 : 10,
                  fontSize: matches.small ? 10 : 14
                }
              }), (_b = (pendingPayments === null || pendingPayments === void 0 ? void 0 : pendingPayments.filter(function (g) {
                return g.loanId == layout.selectedLoanNumber;
              })) || []) === null || _b === void 0 ? void 0 : _b.map(function (d, i) {
                return /*#__PURE__*/React.createElement(PnmacRow, {
                  key: i,
                  flexArr: [3, 2, 2, 2, 3, 3, 2],
                  noBorder: true,
                  data: [/*#__PURE__*/React.createElement(PnmacText, {
                    style: [textStyle.formBody, {
                      paddingRight: matches.small ? 5 : 10
                    }]
                  }, paymentsource[d.draftSource]), /*#__PURE__*/React.createElement(PnmacText, {
                    style: [textStyle.formBody, {
                      paddingRight: matches.small ? 5 : 10
                    }]
                  }, currencyFormatter('en-US', 'currency', 'USD', d.totalDraftAmount)), /*#__PURE__*/React.createElement(PnmacText, {
                    style: [textStyle.formBody, {
                      paddingRight: matches.small ? 5 : 10
                    }]
                  }, accountype[d.bankAccountType]), /*#__PURE__*/React.createElement(PnmacText, {
                    style: [textStyle.formBody, {
                      paddingRight: matches.small ? 5 : 10
                    }]
                  }, maskBankInfo(d.bankAccountNumber)), /*#__PURE__*/React.createElement(PnmacText, {
                    style: [textStyle.formBody, {
                      paddingRight: matches.small ? 5 : 10
                    }]
                  }, moment(d.effectiveDate).format("MM/DD/YYYY")), /*#__PURE__*/React.createElement(PnmacText, {
                    style: [textStyle.formBody, {
                      paddingRight: matches.small ? 5 : 10
                    }]
                  }, d.displayedConfirmationId), /*#__PURE__*/React.createElement(PnmacText, {
                    style: [textStyle.formBody, {
                      paddingRight: matches.small ? 5 : 10
                    }]
                  }, paystatus[d.status])],
                  style: {
                    padding: matches.small ? 0 : 10,
                    paddingLeft: matches.small ? 5 : 10,
                    backgroundColor: i % 2 === 0 ? "#FFF" : "#EFEFEF",
                    borderBottomLeftRadius: i === (pendingPayments === null || pendingPayments === void 0 ? void 0 : pendingPayments.length) - 1 ? 10 : 0,
                    borderBottomRightRadius: i === (pendingPayments === null || pendingPayments === void 0 ? void 0 : pendingPayments.length) - 1 ? 10 : 0
                  },
                  textStyle: {
                    padding: matches.small ? 5 : 0,
                    fontSize: matches.small ? 10 : 14
                  }
                });
              })));
            } else {
              return /*#__PURE__*/React.createElement(React.Fragment, null, edit && /*#__PURE__*/React.createElement(View, {
                style: {
                  paddingTop: 20,
                  paddingBottom: 20,
                  paddingLeft: 40,
                  paddingRight: 40,
                  backgroundColor: "#fff"
                }
              }, /*#__PURE__*/React.createElement(View, {
                style: {
                  backgroundColor: "#1279A5",
                  padding: 10,
                  width: "100%",
                  borderRadius: 10,
                  alignSelf: "center"
                }
              }, /*#__PURE__*/React.createElement(PnmacText, {
                idTag1: 'lblOtpEditingPendingPayment',
                style: __assign(__assign({}, textStyle.defaultTextDescription), {
                  color: "#FFF"
                })
              }, "".concat(translations.OtpEditingPendingPayment, " ").concat(moment((_g = _this.props.layout.mobile ? (_d = (_c = _this.props.route) === null || _c === void 0 ? void 0 : _c.params) === null || _d === void 0 ? void 0 : _d.payment : (_f = (_e = _this.props.location) === null || _e === void 0 ? void 0 : _e.state) === null || _f === void 0 ? void 0 : _f.payment) === null || _g === void 0 ? void 0 : _g.effectiveDate).format("MM/DD/YYYY"))))), /*#__PURE__*/React.createElement(MonthlyPayment, __assign({
                holdViewOpen: function () {
                  _this.setState({
                    holdView: true
                  });
                },
                route: route,
                editPendingPayment: edit,
                isOtp: isOtp,
                disableDebit: function (can) {
                  _this.setState({
                    canUseDebitCard: can || false
                  });
                },
                paymentType: function (data) {
                  return _this.setState({
                    paymentType: data
                  });
                },
                matches: matches
              }, _this.props)));
            }
          } else {
            return null;
          }
        },
        renderSectionHeader: function (_a) {
          var _b, _c, _d;
          var title = _a.section.title;
          var open = ((_b = expRef === null || expRef === void 0 ? void 0 : expRef.current) === null || _b === void 0 ? void 0 : _b.state.collapsed.indexOf(title)) > -1;
          if (title == (translations === null || translations === void 0 ? void 0 : translations.AutoPayApplicationSentOn)) {
            return /*#__PURE__*/React.createElement(BannerView, null, /*#__PURE__*/React.createElement(BannerView.Text, {
              nativeID: 'txtAutoPayVerbiage'
            }, translations.AutoPayApplicationSentOn, " ", moment((_c = layout.paymentModel) === null || _c === void 0 ? void 0 : _c.achConfiguredDate).format("MM/DD/YYYY")));
          } else {
            return /*#__PURE__*/React.createElement(PnmacRowHeader, {
              rowHeaderStyles: styles.selectionListView.rowHeaderStyles,
              rowHeaderContainerStyles: layout.mobile ? {
                marginBottom: open ? 0 : 10,
                borderBottomWidth: open ? 1 : 0,
                borderBottomColor: "#EFEFEF",
                borderBottomLeftRadius: open ? 0 : 10,
                borderBottomRightRadius: open ? 0 : 10
              } : {
                borderBottomWidth: open ? 1 : 0,
                borderBottomColor: "#e9e9e9",
                borderBottomLeftRadius: open ? 0 : 10,
                borderBottomRightRadius: open ? 0 : 10
              },
              onClickExpand: function () {
                return expRef === null || expRef === void 0 ? void 0 : expRef.current.collapseItem(title);
              },
              item: /*#__PURE__*/React.createElement(Text, {
                style: textStyle.formTitleSection
              }, title),
              isExpand: ((_d = expRef === null || expRef === void 0 ? void 0 : expRef.current) === null || _d === void 0 ? void 0 : _d.state.collapsed.indexOf(title)) > -1
            });
          }
        }
      }))) : !isOtp ? /*#__PURE__*/React.createElement(View, {
        style: {
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          alignItems: "center",
          marginTop: 50,
          marginBottom: 50
        }
      }, _this.props.layout.mobile ? /*#__PURE__*/React.createElement(PnmacActivityIndicator, null) : /*#__PURE__*/React.createElement(PnmacSpinner, {
        size: 200,
        color: "#003187",
        loading: true
      })) : /*#__PURE__*/React.createElement(View, {
        style: {
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          alignItems: "center",
          marginTop: 50,
          marginBottom: 50
        }
      }, _this.props.layout.mobile ? /*#__PURE__*/React.createElement(PnmacActivityIndicator, null) : /*#__PURE__*/React.createElement(PnmacSpinner, {
        size: 200,
        color: "#003187",
        loading: true
      }))), /*#__PURE__*/React.createElement(PnmacModal, {
        open: _this.state.howItWorksModal,
        style: {
          paddingHorizontal: 5
        },
        "aria-label": "How It Works"
      }, /*#__PURE__*/React.createElement(ScrollView, null, /*#__PURE__*/React.createElement(View, {
        style: {
          borderRadius: 8,
          backgroundColor: '#ffffff',
          marginVertical: 30,
          paddingHorizontal: 30,
          paddingTop: 20
        }
      }, /*#__PURE__*/React.createElement(View, {
        style: {
          position: 'absolute',
          top: 5,
          right: 5
        }
      }, /*#__PURE__*/React.createElement(TouchableOpacity, {
        style: {
          alignItems: 'flex-end',
          padding: 8
        },
        onPress: function () {
          _this.props.trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Button, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, 'Important-Details/Close|Mobile', -1, "", false);
          _this.setState({
            howItWorksModal: false
          });
        }
      }, /*#__PURE__*/React.createElement(View, {
        style: {
          flexDirection: 'row'
        }
      }, /*#__PURE__*/React.createElement(Image, {
        source: imageAssets.closeIcon,
        style: {
          marginRight: 8,
          marginTop: 8
        }
      })))), /*#__PURE__*/React.createElement(PnmacText, {
        style: __assign(__assign({}, theme.textStyle.modalTitle), {
          fontFamily: "Montserrat",
          fontWeight: "bold",
          textAlign: 'center',
          fontSize: 22,
          paddingTop: 30,
          color: "#333333"
        })
      }, translations.ImportantDetails), /*#__PURE__*/React.createElement(View, {
        style: {
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'space-around',
          paddingVertical: 15
        }
      }, /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(PnmacText, {
        style: {
          color: '#5C5C5C',
          fontSize: 12,
          fontFamily: 'HalenoirCompactText-Medium',
          textAlign: "center"
        }
      }, translations.Payementsone_timepayments, "\n"), /*#__PURE__*/React.createElement(PnmacPaper, {
        style: __assign(__assign({}, styles.oneTimePayment.otpModalContainer), {
          marginVertical: 0
        }),
        disabled: true
      }, /*#__PURE__*/React.createElement(View, {
        style: {
          flexDirection: 'row',
          alignItems: 'flex-start',
          flexWrap: 'wrap'
        }
      }, /*#__PURE__*/React.createElement(PnmacText, {
        style: {
          fontFamily: 'HalenoirCompactText-Bold',
          fontSize: 12,
          color: '#5C5C5C'
        }
      }, translations.Timing, "\n"), timingContent.map(function (item) {
        return renderDisclaimer(item);
      }))), /*#__PURE__*/React.createElement(PnmacPaper, {
        style: __assign(__assign({}, styles.oneTimePayment.otpModalContainer), {
          marginVertical: 0,
          marginTop: 15
        }),
        disabled: true
      }, /*#__PURE__*/React.createElement(View, {
        style: {
          flexDirection: 'row',
          alignItems: 'flex-start',
          flexWrap: 'wrap'
        }
      }, /*#__PURE__*/React.createElement(PnmacText, {
        style: {
          fontFamily: 'HalenoirCompactText-Bold',
          fontSize: 12,
          color: '#5C5C5C'
        }
      }, translations.BankAccountVerification, "\n"), verficationContent.map(function (item) {
        return renderDisclaimer(item);
      }))))), /*#__PURE__*/React.createElement(View, {
        style: {
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'space-around',
          borderBottomColor: '#1B1B1B',
          paddingHorizontal: 8
        }
      }, /*#__PURE__*/React.createElement(PnmacUIButton, {
        style: {
          height: 47,
          justifyContent: "center",
          marginBottom: 20,
          width: '100%'
        },
        mode: "contained",
        onPress: function () {
          _this.props.trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Button, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, 'Important-Details/Make-a-Payment|Mobile', -1, "", false);
          _this.setState({
            howItWorksModal: false
          });
          _this.props.navigation.navigate("Payment", {
            isOtp: true,
            makePayment: true
          });
        }
      }, translations.MakeAPayment))))), /*#__PURE__*/React.createElement(PnmacModal, {
        open: getActiveFeatures(layout.features, 'view_one_time_payment_methods', false) && _this.state.otpConfirmationModal && ((_r = noPaymentConent()) === null || _r === void 0 ? void 0 : _r.length) === 0 && !((_s = route === null || route === void 0 ? void 0 : route.params) === null || _s === void 0 ? void 0 : _s.makePayment),
        style: {
          paddingHorizontal: 5
        },
        "aria-label": translations === null || translations === void 0 ? void 0 : translations.MakeOTPMonthlyPaymentAlertModalTitle
      }, /*#__PURE__*/React.createElement(View, {
        style: {
          borderRadius: 8,
          backgroundColor: '#ffffff',
          marginVertical: 30,
          paddingHorizontal: 30,
          paddingTop: 20
        }
      }, /*#__PURE__*/React.createElement(View, {
        style: {
          position: 'absolute',
          top: 5,
          right: 5
        }
      }, /*#__PURE__*/React.createElement(TouchableOpacity, {
        style: {
          alignItems: 'flex-end',
          padding: 8,
          width: 20,
          height: 20
        },
        onPress: function () {
          var _a;
          _this.props.trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Button, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, 'OTP/payment not due Modal-X|Mobile', -1, '', false);
          _this.setState({
            otpConfirmationModal: false
          });
          _this.props.navigation.navigate("BottomNavBar");
          _this.props.dispatch({
            type: NACHA_BANKACCOUNT,
            paymentModel: __assign(__assign({}, (_a = _this.props.layout) === null || _a === void 0 ? void 0 : _a.paymentModel), {
              selectedView: undefined
            })
          });
        }
      }, /*#__PURE__*/React.createElement(View, {
        style: {
          flexDirection: 'row'
        }
      }, /*#__PURE__*/React.createElement(Image, {
        source: imageAssets.closeIcon,
        style: {
          marginRight: 8,
          marginTop: 8
        }
      })))), /*#__PURE__*/React.createElement(PnmacText, {
        style: __assign(__assign({}, theme.textStyle.modalTitle), {
          fontFamily: "Montserrat",
          fontWeight: "bold",
          textAlign: 'center',
          fontSize: 22,
          paddingTop: 30,
          color: "#333333"
        })
      }, translations === null || translations === void 0 ? void 0 : translations.MakeOTPMonthlyPaymentAlertModalTitle), /*#__PURE__*/React.createElement(View, {
        style: {
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'space-around',
          paddingVertical: 15
        }
      }, /*#__PURE__*/React.createElement(View, {
        style: {
          flex: 1
        }
      }, /*#__PURE__*/React.createElement(PnmacText, {
        style: styles.oneTimePayment.otpModalText
      }, translations.Nopayementdue), /*#__PURE__*/React.createElement(PnmacPaper, {
        style: styles.oneTimePayment.otpModalContainer
      }, /*#__PURE__*/React.createElement(PnmacText, {
        style: styles.oneTimePayment.otpModalText
      }, translations.PostedPayment), /*#__PURE__*/React.createElement(PnmacText, {
        onPress: function () {
          var _a;
          _this.setState({
            otpConfirmationModal: false
          });
          _this.props.dispatch({
            type: NACHA_BANKACCOUNT,
            paymentModel: __assign(__assign({}, (_a = _this.props.layout) === null || _a === void 0 ? void 0 : _a.paymentModel), {
              selectedView: undefined
            })
          });
          _this.props.navigation.navigate("Loan/Activity");
        },
        style: __assign(__assign({}, styles.seeHowItWorksText), {
          textDecorationLine: 'none',
          textAlign: 'center',
          fontFamily: 'HalenoirCompactText-Bold'
        })
      }, translations.ModalLoanActivity), /*#__PURE__*/React.createElement(PnmacText, {
        style: __assign(__assign({}, styles.oneTimePayment.otpModalText), {
          marginVertical: 10
        })
      }, translations.OR), /*#__PURE__*/React.createElement(PnmacText, {
        style: styles.oneTimePayment.otpModalText
      }, translations.PendingPaymentProcessed), /*#__PURE__*/React.createElement(PnmacText, {
        onPress: function () {
          _this.setState({
            otpConfirmationModal: false
          });
          _this.props.navigation.navigate("Payment/Pending");
        },
        style: __assign(__assign({}, styles.seeHowItWorksText), {
          textDecorationLine: 'none',
          textAlign: 'center',
          fontFamily: 'HalenoirCompactText-Bold'
        })
      }, translations.ViewPendingPayments)), /*#__PURE__*/React.createElement(PnmacText, {
        style: __assign({}, styles.oneTimePayment.otpModalText)
      }, translations.NextPaymentDueis, " ", /*#__PURE__*/React.createElement(Text, {
        style: __assign(__assign({}, styles.oneTimePayment.otpModalText), {
          marginVertical: -3,
          textAlign: 'center',
          justifyContent: "center",
          fontFamily: 'HalenoirCompactText-Bold'
        })
      }, moment(currentLoan === null || currentLoan === void 0 ? void 0 : currentLoan.nextPaymentDueDate).format("MM/DD/YYYY"), " ")))), /*#__PURE__*/React.createElement(View, {
        style: textStyle.featuremodal
      }, /*#__PURE__*/React.createElement(PnmacUIButton, {
        style: {
          height: 47,
          justifyContent: "center",
          marginBottom: 20,
          width: '100%'
        },
        mode: "contained",
        onPress: function () {
          _this.props.trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Button, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, 'OTP/payment not due Modal-Continue|Mobile', -1, '', false);
          _this.setState({
            otpConfirmationModal: false
          });
        }
      }, translations === null || translations === void 0 ? void 0 : translations.MakeOTPMonthlyPaymentAlertModalContinue)), /*#__PURE__*/React.createElement(View, {
        style: textStyle.featuremodal
      }, /*#__PURE__*/React.createElement(PnmacUIButton, {
        style: {
          height: 47,
          justifyContent: "center",
          marginBottom: 20,
          width: '100%'
        },
        mode: "outlined",
        onPress: function () {
          var _a;
          _this.props.trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Button, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, 'OTP/payment not due Modal-Cancel|Mobile', -1, '', false);
          _this.setState({
            otpConfirmationModal: false
          });
          _this.props.dispatch({
            type: NACHA_BANKACCOUNT,
            paymentModel: __assign(__assign({}, (_a = _this.props.layout) === null || _a === void 0 ? void 0 : _a.paymentModel), {
              selectedView: undefined
            })
          });
          _this.props.navigation.navigate("BottomNavBar");
        }
      }, translations.Cancel)))));
    });
  };
  return Payment;
}(Component);
var mapStateToProps = function (state) {
  return {
    layout: state,
    translations: state.translations
  };
};
var mapDispatchToProps = function (dispatch) {
  var Actions = require("../../redux/actions/actions.js");
  return __assign({
    dispatch: dispatch
  }, bindActionCreators(Actions, dispatch));
};
function checkTitle(props) {
  var _a, _b, _c, _d;
  if (props.lamp || ((_b = (_a = props.route) === null || _a === void 0 ? void 0 : _a.params) === null || _b === void 0 ? void 0 : _b.lamp)) {
    return "LAMP OTP MODULE";
  }
  if (Platform.OS === 'web') {
    return props.isOtp ? props.translations.OtpPageTitle : props.translations.automaticPayments;
  } else {
    return ((_d = (_c = props.route) === null || _c === void 0 ? void 0 : _c.params) === null || _d === void 0 ? void 0 : _d.isOtp) ? !getActiveFeatures(props.layout.features, "view_one_time_payment_methods", false) ? props.translations.OtpPageTitle : '' : !getActiveFeatures(props.layout.features, "Payment_Autopay", false) ? props.translations.automaticPayments : '';
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(withPnmacTitle(Payment, checkTitle));